





































import Vue from 'vue';
import { loginFormService } from '@/main/services';
import _ from 'lodash';

import { ERROR, SET_RESET_PASSWORD } from '../store/actionTypes';

export default Vue.extend({
	name: 'PasswordReset',
	props: {
		login: { type: String, required: true },
	},
	data() {
		return {
			passwordOld: null as string | null,
			passwordNew1: null as string | null,
			passwordNew2: null as string | null,
		};
	},
	computed: {
		btnDisabled(): Boolean {
			return !this.passwordOld || !this.passwordNew1 || !this.passwordNew2;
		},
	},
	methods: {
		async editPassword() {
			const loading = this.$loading({ fullscreen: true });

			const [tenant, login] = this.login.split('\\');
			const editData = { login, ..._.pick(this.$data, ['passwordOld', 'passwordNew1', 'passwordNew2']) };
			try {
				await loginFormService.changePassword(editData, tenant);
				this.$store.commit(SET_RESET_PASSWORD, false);
			} catch (error) {
				this.$store.dispatch(ERROR, { error });
			} finally {
				loading.close();
			}
		},
		nextFocus(elementRef: string) {
			(this.$refs[elementRef] as HTMLElement).focus();
		},
	},
});
